import api from 'data/api';

export const createPreset = api('POST /api/user/presets');
